/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import React, { useCallback, useMemo } from 'react';
import { Wrapper } from '../layout/header';
import styled from 'styled-components';
import { Colors } from '../../constant/color';
import CarCarousel from '../car-carousel';
import { Button, Col, Row } from 'antd';
import { ValuationComparing } from '../../interfaces/valuation';
import { LoanOfficerSideCard } from './loan-officer-card';
import useSWR from 'swr';
import { GeneralApi, UserApi } from '../../apis';
import { PermissionCode } from '../../hook/use-role';
import { AppraisalSideCard } from './appraisal-side-card';
import { BranchDirectorSideCard } from './branch-director-side-card';
import { BranchDirector } from './branch-director';
import { ValuationPdfDownload } from './valuation-pdf-download';
import { LoanOfficer } from './loan-officer';
import { Appraisal } from './appraisal';
import { CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { PencilLineIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

type Props = {
  payload: ValuationComparing;
};

export const getKeyValue = ({
  key,
  option,
  init,
}: {
  key?: string | null;
  option: string;
  init: any;
}) => {
  if (init && key) {
    const val = (init[option] || []).find((item: any) => item.code === key);

    console.log('val: ', val);
    if (val) {
      return val.name;
    } else {
      return key;
    }
  }
  return key;
};

const Report = ({ payload }: Props) => {
  const { data: me } = useSWR('swr.user.me', UserApi.me);
  const { data: init } = useSWR('/api/init', () => GeneralApi.init());

  const navigate = useNavigate();

  const sideCardRender = useMemo(() => {
    if (me?.isBranchHead || me?.permissions[PermissionCode.VALUATION_FINALIZE_CONFIRM]?.hasAccess) {
      return (
        <div>
          <BranchDirectorSideCard payload={payload} />
        </div>
      );
    }

    if (me?.permissions[PermissionCode.VALUATION]?.isCreate) {
      return (
        <div>
          <LoanOfficerSideCard payload={payload} />
        </div>
      );
    }
    if (me?.permissions[PermissionCode.APPRAISER]?.hasAccess) {
      return (
        <div>
          <AppraisalSideCard payload={payload} />
        </div>
      );
    }
    return 'EMPTY';
  }, [me?.permissions, me?.isBranchHead, payload]);

  function renderForm() {
    if (payload.status === 'VALUATED' &&
        me?.permissions?.[PermissionCode.VALUATION_PDF]?.hasAccess) {
      return <ValuationPdfDownload payload={payload} hasAccess={true} />;
    }

    // if (payload.status === 'REJECTED' || payload.status === 'VALUATED') {
    //   return null;
    // }


    console.log("me?.permissions[PermissionCode.VALUATION_FINALIZE_CONFIRM]?.hasAccess :", me?.permissions[PermissionCode.VALUATION_FINALIZE_CONFIRM]?.hasAccess);

    if (me?.isBranchHead) {
      return <BranchDirector />;
    }

    if (me?.permissions[PermissionCode.VALUATION_FINALIZE_CONFIRM]?.hasAccess) {
      return <BranchDirector isBranchPercentConfirm={true} />;
    }

    if (me?.permissions[PermissionCode.VALUATION]?.isCreate) {
      return <LoanOfficer />;
    }

    if (me?.permissions[PermissionCode.APPRAISER]?.hasAccess) {
      return <Appraisal payload={payload} />;
    }

    

    return 'EMPTY';
  }

  const onEdit = () => {
    navigate(`/valuation/edit/${payload?.id}`);
  };

  const alert = useCallback(
    (type: 'error' | 'warning') => {
      if (payload.status === 'REJECTED') {
        return (
          <div className="flex flex-row border-l-[5px] border-[#E53935] pl-[13px] items-center bg-[#FFECEC] p-[2px]">
            <div>
              <ExclamationCircleOutlined style={{ color: '#E53935', fontSize: '24px' }} />
            </div>
            <div className="flex flex-col justify-center bg-[#FFECEC] p-[12px]">
              <label className="font-manrope font-semibold text-[18px] leading-[26px] tracking-[-0.9px]">
                Татгалзсан
              </label>
              <label className="font-manrope font-[400] text-[16px] leading-[26px] tracking-[-0.9px]">
                {payload?.note}
              </label>
              <label className="font-manrope font-[400] text-[14px] leading-[16px] tracking-[-0.9px]">
                Буцаасан: {payload?.appraiser?.lastName} {payload?.appraiser?.firstName} ·
                {dayjs(payload?.updatedAt).format('YYYY-MM-DD HH:mm')}
              </label>
            </div>
          </div>
        );
      }

      if (payload.status === 'RETURNED') {
        return (
          <>
            <div className="flex flex-row border-l-[5px] border-[#FFA726] pl-[13px] items-center bg-[#FFF3E2] p-[2px]">
              <div>
                <ExclamationCircleOutlined style={{ color: '#faad14', fontSize: '24px' }} />
              </div>
              <div className="flex flex-col justify-center bg-[#FFF3E2] p-[12px]">
                <label className="font-manrope font-semibold text-[18px] leading-[26px] tracking-[-0.9px]">
                  Буцаагдсан
                </label>
                <label className="font-manrope font-[400] text-[16px] leading-[26px] tracking-[-0.9px]">
                  {payload?.note}
                </label>
                <label className="font-manrope font-[400] text-[14px] leading-[26px] tracking-[-0.9px]">
                  Буцаасан: {payload?.appraiser?.lastName} {payload?.appraiser?.firstName} ·
                  {dayjs(payload?.updatedAt).format('YYYY-MM-DD HH:mm')}
                </label>
              </div>
            </div>

            {me?.id === payload?.valuationUser?.id && (
              <div className="flex flex-row justify-end py-[5px]">
                <Button type="primary" onClick={onEdit}>
                  <PencilLineIcon width={15} height={15} strokeWidth={2} />
                  Засах
                </Button>
              </div>
            )}
          </>
        );
      }

      if (payload.status === 'VALUATED') {
        return (
          <>
            <div className="flex flex-row border-l-[5px] border-[#389e0d] pl-[13px] items-center bg-[#f6ffed] p-[2px]">
              <div>
                <CheckCircleOutlined style={{ color: '#389e0d', fontSize: '24px' }} />
              </div>
              <div className="flex flex-col justify-center  p-[12px]">
                <label className="font-manrope font-semibold text-[18px] leading-[26px] tracking-[-0.9px]">
                  Үнэлсэн
                </label>
                <label className="font-manrope font-[400] text-[14px] leading-[26px] tracking-[-0.9px]">
                  Үнэлсэн: {payload?.valuatedUser?.lastName} {payload?.valuatedUser?.firstName} ·
                  {dayjs(payload?.updatedAt).format('YYYY-MM-DD HH:mm')}
                </label>
              </div>
            </div>
          </>
        );
      }
    },
    [
      payload?.appraiser?.firstName,
      payload?.appraiser?.lastName,
      payload?.note,
      payload?.status,
      payload?.updatedAt,
    ]
  );

  const carouselImages = useMemo(() => {
    if (
      payload?.frontImage?.url &&
      payload?.backImage?.url &&
      payload?.rightImage?.url &&
      payload?.leftImage?.url &&
      payload?.saloonImage?.url &&
      payload?.hoodImage?.url &&
      payload?.odoImage?.url &&
      payload?.vehicleImages
    ) {
      return [
        payload.frontImage?.url || '',
        payload.backImage?.url || '',
        payload.rightImage?.url || '',
        payload.leftImage?.url || '',
        payload.saloonImage?.url || '',
        payload.hoodImage?.url || '',
        payload.odoImage?.url || '',
        [...(payload && payload?.vehicleImages.map((image) => image.url))],
      ];
    }
    return [...(payload && payload?.vehicleImages.map((image) => image.url))];
  }, []);

  return (
    <Container>
      <PageContainer>
        <div className="w-full h-full">
          <Container className="bg-[white]">
            <div className="flex-col bg-white rounded-[8px] p-5 ">
              {/* {alert('error')} */}
              {alert('warning')}
              <div className="h-[30px]" />
              <Wrapper>
                <div className="flex flex-row gap-[30px]">
                  <div>
                    <div className="flex flex-row items-center">
                      <div className="flex flex-col border-l-[5px] border-[#5869FF] pl-[20px] justify-center  ">
                        <label className="font-manrope font-semibold text-[30px] leading-[56px] tracking-[-0.9px]">
                          Автомашины үнэлгээ
                        </label>
                        <div className="font-manrope text-[19px] leading-[32px] tracking-[-0.18px] font-[400] text-[#6A6A6A]">
                          {/* Toyota Land Cruiser 200 */}
                          {payload.vehicle.carBrand.name} {payload.vehicle.carModel.name}
                        </div>
                      </div>
                    </div>
                    <div className="h-[20px]" />
                    <div className="w-[500px]  p-[17px]">
                      <div>
                        {/* <CarCarousel images={images as any} /> */}

                        <CarCarousel images={carouselImages as any} />
                      </div>
                      <div className="h-[20px]" />
                      {/*  */}

                      {sideCardRender}
                      {/*  */}
                    </div>
                  </div>
                  {/* 11111 */}
                  <div className="h-[949px] opacity-100 flex flex-col gap-[15px] ">
                    <div className="border border-[#dce4ec] rounded-[14px] p-[37px]">
                      <div className="flex flex-col justify-center items-center h-[32px]">
                        <div className="  font-manrope font-semibold text-[20px] leading-[32px] tracking-[-0.02em] text-center text-[#282830]">
                          Автомашины ерөнхий мэдээлэл
                        </div>
                        {/* grid 6 col 2row */}
                      </div>
                      <div className="h-[30px] w-[30px]"></div>
                      <div className="flex w-full flex-col">
                        <Row className="flex w-full" gutter={20}>
                          <Col span={6}>
                            {/* item */}
                            <div className="w-full h-full">
                              <div className=" font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
                                Үйлдвэрлэсэн он
                              </div>
                              <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
                                {payload.vehicle.manufacturedYear}
                              </div>
                            </div>
                            {/* item */}
                          </Col>
                          <Col span={6}>
                            {/* item */}
                            <div className="w-full h-full">
                              <div className=" font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
                                Монгол Улсад орж ирсэн он
                              </div>
                              <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
                                {payload.vehicle.importedYear}
                              </div>
                            </div>
                            {/* item */}
                          </Col>
                          <Col span={6}>
                            {/* item */}
                            <div className="w-full h-full">
                              <div className=" font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
                                Хурдны хайрцаг
                              </div>
                              <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
                                {payload.vehicle.transmission === 'AUTO' ? 'Автомат' : 'Хоолой'}
                              </div>
                            </div>
                            {/* item */}
                          </Col>
                          <Col span={6}>
                            {/* item */}
                            <div className="w-full h-full">
                              <div className=" font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
                                Жолооны хүрд
                              </div>
                              <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
                                {payload.vehicle.steering === 'LEFT'
                                  ? 'Зүүн талдаа'
                                  : 'Баруун талдаа'}
                              </div>
                            </div>
                            {/* item */}
                          </Col>
                        </Row>
                        <div className="h-[16px] w-[30px] "></div>
                        <Row className="flex w-full" gutter={20}>
                          <Col span={6}>
                            {/* item */}
                            <div className="w-full h-full">
                              <div className=" font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
                                Автомашины төрөл
                              </div>
                              <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
                                {payload.vehicle.type}
                                {getKeyValue({
                                  key: payload?.vehicle?.type,
                                  option: 'vehicleTypes',
                                  init: init,
                                })}
                              </div>
                            </div>
                            {/* item */}
                          </Col>
                          <Col span={6}>
                            {/* item */}
                            <div className="w-full h-full">
                              <div className=" font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
                                Хөдөлгүүрийн багтаамж
                              </div>
                              <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
                                {payload.vehicle.engineCapacity}
                              </div>
                            </div>
                            {/* item */}
                          </Col>
                          <Col span={6}>
                            {/* item */}
                            <div className="w-full h-full">
                              <div className=" font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
                                Хөтлөгчийн төрөл
                              </div>
                              <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
                                {getKeyValue({
                                  key: payload?.vehicle?.drivetrain,
                                  option: 'drivetrain',
                                  init: init,
                                })}
                              </div>
                            </div>
                            {/* item */}
                          </Col>
                          <Col span={6}>
                            {/* item */}
                            <div className="w-full h-full">
                              <div className=" font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
                                Тоноглол
                              </div>
                              <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
                                {/* {payload.vehicle.option?.name || ''} */}
                              </div>
                            </div>
                            {/* item */}
                          </Col>
                        </Row>
                        <div className="h-[30px] w-[30px]"></div>
                        <Row className="flex w-full" gutter={20}>
                          <Col span={5}>
                            {/* item */}
                            <div className="w-full h-full">
                              <div className=" font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
                                Арлын дугаар
                              </div>
                              <div className="font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830] break-all">
                                {payload.vehicle.vin}
                              </div>
                            </div>
                            {/* item */}
                          </Col>
                          <Col span={4}>
                            {/* item */}
                            <div className="w-full h-full">
                              <div className=" font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
                                Хурдны хайрцаг
                              </div>
                              <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
                                {/* {payload?.vehicle?.transmission} */}
                                {getKeyValue({
                                  key: payload?.vehicle?.transmission,
                                  option: 'transmissionTypes',
                                  init: init,
                                })}
                              </div>
                            </div>
                            {/* item */}
                          </Col>
                          <Col span={5}>
                            {/* item */}
                            <div className="w-full h-full">
                              <div className=" font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
                                Хөдөлгүүрийн төрөл
                              </div>
                              <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
                                {/* {payload.vehicle.engineType} */}
                                {getKeyValue({
                                  key: payload.vehicle.engineType,
                                  option: 'engineTypes',
                                  init: init,
                                })}
                              </div>
                            </div>
                            {/* item */}
                          </Col>

                          <Col span={5}>
                            {/* item */}
                            <div className="w-full h-full">
                              <div className=" font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
                                Зориулалт
                              </div>
                              <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
                                <span className="value printValue">{payload?.vehicle?.type}</span>
                              </div>
                            </div>
                            {/* item */}
                          </Col>
                        </Row>
                      </div>

                      <div className="h-[24px] w-[30px]"></div>

                      <div className="flex w-full flex-col">
                        <Row className="flex w-full" gutter={20}>
                          <Col span={4}>
                            {/* item */}
                            <div className="w-full h-full">
                              <div className=" font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
                                Хянах самбарын гэрэл
                              </div>
                              <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
                                {getKeyValue({
                                  key: payload.warningLightCondition,
                                  option: 'warningLightConditions',
                                  init: init,
                                })}
                              </div>
                            </div>
                            {/* item */}
                          </Col>
                          <Col span={4}>
                            {/* item */}
                            <div className="w-full h-full">
                              <div className=" font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
                                Мотор, хропны ерөнхий чанар
                              </div>
                              <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
                                {getKeyValue({
                                  key: payload.engineTransmissionCondition,
                                  option: 'engineTransmissionConditions',
                                  init: init,
                                })}
                              </div>
                            </div>
                            {/* item */}
                          </Col>
                          <Col span={5}>
                            {/* item */}
                            <div className="w-full h-full">
                              <div className=" font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
                                Гэрэл, дохио бүрэн бүтэн
                              </div>
                              <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
                                {getKeyValue({
                                  key: payload.lightCondition,
                                  option: 'lightConditions',
                                  init: init,
                                })}
                              </div>
                            </div>
                            {/* item */}
                          </Col>

                          <Col span={5}>
                            {/* item */}
                            <div className="w-full h-full">
                              <div className=" font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
                                Шил бүрэн, бүтэн эсэх
                              </div>
                              <div className=" font-manrope font-medium text-[16px] leading-[24px] tracking-[-0.48px] text-[#282830]">
                                {getKeyValue({
                                  key: payload.windowCondition,
                                  option: 'windowConditions',
                                  init: init,
                                })}
                              </div>
                            </div>
                            {/* item */}
                          </Col>
                        </Row>
                        <div className="h-[24px] w-[30px]"></div>
                        <Row className="flex w-full" gutter={20}>
                          <Col span={12}>
                            <div>
                              <div className="font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
                                Осолд орж байсан шинж тэмдэг байгаа эсэхийг сайтар ажиглах
                              </div>
                              <div className="h-[8px] w-[36px]" />
                              <div className="font-manrope font-medium text-[14px] leading-[24px] tracking-[-0.42px] text-[#282830]">
                                {payload.accidentNote}
                              </div>
                            </div>
                          </Col>
                          <div className="h-[16px] w-[36px]"></div>
                          <Col span={10}>
                            <div>
                              <div className="font-manrope font-normal text-[14px] leading-[20px] tracking-[-0.28px] text-[#6A6A6A]">
                                Онцгойлох зураас, сэв, хонхойлтыг тэмдэглэх.
                              </div>
                              <div className="h-[8px] w-[36px]" />
                              <div className="font-manrope font-medium text-[14px] leading-[24px] tracking-[-0.42px] text-[#282830]">
                                {payload.scratchNote}
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>

                      {/* asdasdas */}
                    </div>

                    {payload && payload?.odoImage?.url && (
                      <div className="w-full h-[260px] flex gap-[10px]">
                        <div className="h-[320px] flex-1 flex items-center justify-start bg-white rounded-[8px] overflow-hidden flex-col">
                          <img
                            src={payload.odoImage?.url}
                            className="h-[250px] object-cover rounded-[8px]"
                          />
                          <div className="h-[10px]" />
                          <div className="font-manrope font-medium text-[14px] leading-[21px] tracking-[-0.28px] text-center text-[#B4B7C9]">
                            Явсан км: {payload.odo}
                          </div>
                        </div>

                        <div className=" h-[320px] flex-1 flex items-center justify-start bg-white rounded-[8px] overflow-hidden flex-col">
                          <img
                            src={payload.saloonImage?.url}
                            className="h-[250px] object-cover rounded-[8px]"
                          />
                          <div className="h-[10px]" />
                          <div className="font-manrope font-medium text-[14px] leading-[21px] tracking-[-0.28px] text-center text-[#B4B7C9]">
                            {payload?.saloonCondition === 'GOOD'
                              ? 'Цэвэр'
                              : payload?.saloonCondition === 'NORMAL'
                              ? 'Эвдрэлгүй'
                              : 'Эвдрэл'}
                          </div>
                        </div>

                        <div className="h-[320px] flex-1 flex items-center justify-start bg-white rounded-[8px] overflow-hidden flex-col">
                          <img
                            src={payload.hoodImage?.url}
                            className="h-[250px] object-cover rounded-[8px]"
                          />
                          <div className="h-[10px]" />
                          <div className="font-manrope font-medium text-[14px] leading-[21px] tracking-[-0.28px] text-center text-[#B4B7C9]">
                            {payload?.hoodNote}
                          </div>
                        </div>
                      </div>
                    )}

                    {/*  */}
                  </div>
                </div>
              </Wrapper>
            </div>

            {renderForm()}

            {/*  */}
            {/* {payload && <Appraisal payload={payload} />} */}
            {/* <BranchDirector action={{ loading: false, payload: {} }} /> */}
            {/* <LoanOfficer /> */}
            {/*  */}

            <div className="h-[100px]" />
          </Container>
        </div>
      </PageContainer>
    </Container>
  );
};

const Container = styled.div`
  .ant-btn-color-primary {
    background-color: ${Colors.blue} !important;
  }
  .ant-tabs-tab {
    margin: 0 5px !important;
  }
`;

const PageContainer = styled.div`
  width: 100%;
  height: 85vh;
  overflow-y: auto;
  /* scrollbar-hide */
`;

export { Report };
